import { createRoutine } from "redux-saga-routines";

export const loadAll = createRoutine("ORDER/LOAD_ALL");
export const loadOne = createRoutine("ORDER/LOAD_ONE");
export const create = createRoutine("ORDER/CREATE");
export const deleteOne = createRoutine("ORDER/DELETE");
export const update = createRoutine("ORDER/UPDATE");
